/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

export enum SettlementColumnEnum {
    CUSTOMER = 'CUSTOMER',
    SUPPLIER = 'SUPPLIER',
    STATUS = 'STATUS',
    COMPLAINT_CODE = 'COMPLAINT_CODE',
    SETTLEMENT_CODE = 'SETTLEMENT_CODE',
    LAST_PENDING_DATE = 'LAST_PENDING_DATE',
    LAST_CHANGE_DATETIME = 'LAST_CHANGE_DATETIME',
    MATERIALS_TOTAL_GROSS_COST = 'MATERIALS_TOTAL_GROSS_COST',
    TE_MINUTES_TOTAL_COST = 'TE_MINUTES_TOTAL_COST',
    SETTLEMENT_TOTAL_COST = 'SETTLEMENT_TOTAL_COST',
}
